import { createContext } from "react";

// Define action types
export type ConfigAction =
  | { type: "WIDGETS_VISIBILITY"; payload: { visible: boolean } }
  | { type: "SETTINGS_VISIBILITY"; payload: { visible: boolean } }
  | { type: "SHARE_VISIBILITY"; payload: { visible: boolean } }
  | { type: "DRAWER_VISIBILITY"; payload: { visible: boolean } }
  | { type: "NOTIFICATIONS_VISIBILITY"; payload: { visible: boolean } }
  | { type: "SEARCH_VISIBILITY"; payload: { visible: boolean } }
  | { type: "MOBILE_SEARCH_VISIBILITY"; payload: { visible: boolean } }
  | { type: "SEARCH_INPUT_VALUE"; payload: { value: string } };

// Define state interface
export interface ConfigStateValue {
  isWidgetsOpen: boolean;
  isSettingsOpen: boolean;
  isShareOpen: boolean;
  isDrawerOpen: boolean;
  isNotificationsOpen: boolean;
  isSearchOpen: boolean;
  isMobileSearchOpen: boolean;
  searchInputValue: string;
}

// Initial state
export const initialConfigState: ConfigStateValue = {
  isWidgetsOpen: false,
  isSettingsOpen: false,
  isShareOpen: false,
  isDrawerOpen: false,
  isNotificationsOpen: false,
  isSearchOpen: false,
  isMobileSearchOpen: false,
  searchInputValue: "",
};

export const ConfigContext = createContext<{
  state: ConfigStateValue;
  dispatch: React.Dispatch<ConfigAction>;
  settingsRef: React.RefObject<HTMLDivElement | null>;
  widgetSwitchRef: React.RefObject<HTMLDivElement | null>;
  shareRef: React.RefObject<HTMLDivElement | null>;
  drawerSwitchRef: React.RefObject<HTMLDivElement | null>;
  notificationsRef: React.RefObject<HTMLDivElement | null>;
  searchRef: React.RefObject<HTMLDivElement | null>;
}>({
  state: initialConfigState,
  dispatch: () => {},
  settingsRef: { current: null },
  widgetSwitchRef: { current: null },
  shareRef: { current: null },
  drawerSwitchRef: { current: null },
  notificationsRef: { current: null },
  searchRef: { current: null },
});
